// ── Stałe i funkcje pomocnicze ────────────────────────────────────────────────
// Brak zewnętrznych zależności.

export const POZYCJE = ["Bramkarz", "Obrońca", "Pomocnik", "Napastnik", "Skrzydłowy"];
export const TYPY = ["Trening grupowy", "Trening indywidualny", "Siłownia", "Interwały", "Regeneracja", "Taktyczny", "Strzelecki", "Rehabilitacja"];

export const REHAB_PHASES = [
  { id: 1, icon: "🛑", label: "Odpoczynek",          desc: "Pełna przerwa — leczenie i redukcja stanu zapalnego" },
  { id: 2, icon: "🚶", label: "Ćwiczenia ogólne",    desc: "Ruch bez obciążenia kontuzjowanej partii" },
  { id: 3, icon: "🏃", label: "Trening specyficzny", desc: "Ćwiczenia piłkarskie bez kontaktu" },
  { id: 4, icon: "⚽", label: "Powrót do drużyny",   desc: "Pełny trening — gotowość do gry" },
];

export const CZESC_CIALA = [
  "Kolano prawe", "Kolano lewe",
  "Kostka prawa", "Kostka lewa",
  "Udo prawe", "Udo lewe",
  "Łydka prawa", "Łydka lewa",
  "Plecy / kręgosłup",
  "Ramię / bark",
  "Głowa",
  "Inne",
];

// Zawsze format ISO YYYY-MM-DD z UTC
export const today = () => new Date().toISOString().split("T")[0];

// Krótkie losowe ID (8 znaków base-36)
export const uid = () => Math.random().toString(36).slice(2, 10);

// Walidacja siły hasła — min. 6 znaków + odrzucenie oczywistych haseł.
// Bez wymuszania wielkich liter/cyfr/znaków specjalnych (NIST 800-63B:
// długość > sztuczna złożoność).
//
// UWAGA: to jedyna kontrola poza minimum Firebase Auth (6 znaków) i działa
// WYŁĄCZNIE w UI — da się ją obejść z konsoli przeglądarki. Serwer hasła nie
// widzi: ustawia je klient przez createUserWithEmailAndPassword(), a Cloud
// Functions dostają już tylko token. Wcześniejszy komentarz twierdził, że
// "CF re-waliduje" — nieprawda, tamta funkcja leżała martwa (patrz
// functions/index.js, sekcja o braku serwerowej walidacji hasła).
// Obejście szkodzi tylko koncie, które je stosuje, nie cudzym danym.
const COMMON_PASSWORDS = new Set([
  "password", "password1", "password123", "12345678", "123456789", "1234567890",
  "qwerty123", "qwertyuiop", "admin123", "welcome123", "letmein123", "iloveyou1",
  "football1", "footlog123", "zaq12wsx", "haslo1234", "haslo123", "trener123",
  "rodzic123", "12345678910", "abc123456", "passw0rd", "123123123", "111111111",
]);

export function isPasswordStrongEnough(pass) {
  if (!pass || pass.length < 6) return false;
  if (COMMON_PASSWORDS.has(pass.toLowerCase())) return false;
  return true;
}

// Pusty obiekt zawodnika — używany jako fallback gdy ST.child() zwraca null
// 4-filarowy model PZNP:
//   • sessionMental — ankieta nastroju po treningu/meczu (rating 1–5)
//   • dailySleep    — poranny check-in snu (hours + quality 1–5)
export const emptyChild = (opts = {}) => ({
  name:    opts.name    || "",
  klub:    opts.klub    || "",
  pozycja: opts.pozycja || "Pomocnik",
  numer:   opts.numer   || "",
  mecze: [], treningi: [], sessionMental: [], dailySleep: [], dailyPain: [], goals: [],
  stats: { wiek: opts.wiek || "15" },
});

// ── Wiek zawodnika ────────────────────────────────────────────────────────────
// Jedyne źródło prawdy: `stats.wiek` (edytowane w zakładce Dane fizyczne).
// Wcześniej wiek żył równolegle w `child.wiek` i `child.stats.wiek`; pola cicho
// się rozjeżdżały, bo zapis szedł tylko do jednego. Kosztowne, bo
// getLoadThresholds() robi `parseInt(age) || 16` — 12-latek ze stale'owym polem
// dostawał progi obciążenia nastolatka.
// Czytaj przez ten helper, nie przez surowe pole.
export function getWiek(child, team) {
  // Rocznik drużyny bije pole ręczne, bo samo się aktualizuje. Pole `stats.wiek`
  // wpisuje rodzic raz przy zakładaniu konta i nic go potem nie podbija —
  // zawodnik, który wpisał 12 dwa lata temu, nadal jechał na progach
  // dwunastolatka. Przy wskaźnikach skalowanych wiekiem to podkopuje fundament.
  const rocznik = parseInt(team?.birthYear, 10);
  if (Number.isFinite(rocznik) && rocznik > 1900) {
    const lat = new Date().getUTCFullYear() - rocznik;
    if (lat > 0 && lat < 100) return String(lat);
  }
  return child?.stats?.wiek || "";
}
